import type { Nullable } from '@gov-nx/core/types';

export enum GunListType {
	UPLNY = 'UPLNY',
	CASTECNY = 'CASTECNY',
}

export type CategoryRowValue =
	| string
	| (string | undefined)[]
	| { [key: string]: string | undefined }
	| { [key: string]: string | undefined }[]
	| undefined;

/**
 * Represents either a simple category (key-value pairs) or a category with nested items
 */
export type Category = SimpleCategoryType | CategoryWithItems;

/**
 * Represents an item within a category that has an items array
 */
export type CategoryItem = {
	[key: string]: CategoryRowValue;
	id: string;
};

/**
 * Simple category type with key-value pairs
 */
export type SimpleCategoryType = {
	type: 'simple';
	[key: string]: CategoryRowValue;
	id: string;
};

/**
 * Category type that contains an array of items
 */
export type CategoryWithItems = {
	type: 'list';
	items: CategoryItem[];
};

export type UserDataFromCrz = {
	prijmeni: string | undefined;
	jmeno: string | undefined;
	datumNarozeni: string | undefined;
	dokladDrziteleType: string | undefined;
	email: string | undefined;
	telefon: string | undefined;
};

type XVal = Nullable<{ xVal: string }>;

export type Raze = {
	kod: XVal;
	value: XVal;
};

export type VedlejsiDrzitelFO = {
	prijmeniVedlejsihoDrziteleType: XVal;
	jmenoVedlejsihoDrziteleType: XVal;
	datumNarVedlejsihoDrziteleType: XVal;
};

// This will get replaced with a generated type, this is only temporary inferred type
export type CrzResponse = {
	Data: [
		{
			r:
				| {
						xAttAis: string;
						status: XVal;
						detail: XVal[];
						crzOdpoved: {
							kontextData: {
								identifikator: XVal;
								entitaGsb: {
									aifo: XVal;
								};
								osobaDrzitel: {
									jmeno: XVal;
									prijmeni: XVal;
									datumNarozeni: XVal;
									telefon: XVal;
									email: XVal;
									dokladDrziteleType: {
										cislo: XVal;
										druh: XVal;
									};
								};
								zbrojniOpravneni: {
									druhZbrojnihoOpravneni: {
										kod: XVal;
										value: XVal;
									};
									datumZapisu: XVal;
									stavZbrojnihoOpravneni: {
										kod: XVal;
										value: XVal;
									};
									zdravotniZpusobilostDo: XVal;
									omezeniZdravotniZpusobilosti: XVal;
									id: XVal;
								};
								zbrojniLicence: {
									druhZbrojniLicence: {
										kod: XVal;
										value: XVal;
									};
									datumZapisu: XVal;
									stavZbrojniLicence: {
										kod: XVal;
										value: XVal;
									};
									id: XVal;
								};
								evropskyZbrojniPas: {
									cislo: XVal;
									datumVydani: XVal;
									datumPlatnostiDo: XVal;
									stavEvropskehoZbrojnihoPasu: {
										kod: XVal;
										value: XVal;
									};
									id: XVal;
								}[];
								municniOpravneniNakladaniMunice: {
									druhMunicnihoOpravneni: {
										kod: XVal;
										value: XVal;
									};
									datumZapisu: XVal;
									stavOpravneni: {
										kod: XVal;
										value: XVal;
									};
									zdravotniZpusobilostDo: XVal;
									omezeniZdravotniZpusobilosti: XVal;
									id: XVal;
								}[];
								aprobace: {
									datumZapisu: XVal;
									druhAprobace: {
										kod: XVal;
										value: XVal;
									};
									id: XVal;
								}[];
								zapsanaAutorizace: {
									datumZapisu: XVal;
									stavAutorizace: {
										kod: XVal;
										value: XVal;
									};
									id: XVal;
								};
								ohlaseneZbraneKategoriePO: {
									druhZbrane: {
										kod: XVal;
										value: XVal;
									};
									popisHlavniCastiZbrane?: XVal;
									vyrobniCislo: XVal | XVal[];
									vyrobce: {
										kod: XVal;
										value: XVal;
									};
									vzor: {
										kod: XVal;
										value: XVal;
									};
									raze?: Raze | Raze[];
									datumZapisu: XVal;
									id: XVal;
								}[];
								povoleniNaZbranKategorieR3: {
									cisloJednaci: XVal;
									datumZapisu: XVal;
									id: XVal;
								}[];
								vedlejsiZbrane: {
									kategorie: {
										kod: XVal;
										value: XVal;
									};
									druhZbrane: {
										kod: XVal;
										value: XVal;
									};
									vyrobniCislo: XVal | XVal[];
									vyrobce: {
										kod: XVal;
										value: XVal;
									};
									popisHlavniCastiZbrane: XVal;
									vzor: {
										kod: XVal;
										value: XVal;
									};
									raze: Raze | Raze[];
									datumZapisu: XVal;
									id: XVal;
								}[];
								zbraneHlavnihoDrziteleR1R2R3R4: {
									vedlejsiDrzitelFO: VedlejsiDrzitelFO | VedlejsiDrzitelFO[];
									kategorie: {
										kod: XVal;
										value: XVal;
									};
									druhZbrane: {
										kod: XVal;
										value: XVal;
									};
									popisHlavniCastiZbrane: XVal;
									vyrobniCislo: XVal | XVal[];
									vyrobce: {
										kod: XVal;
										value: XVal;
									};
									vzor: {
										kod: XVal;
										value: XVal;
									};
									raze: Raze | Raze[];
									datumZapisu: XVal;
									id: XVal;
								}[];
								vyjimkyNaNadlimitniZasobnik: {
									cisloJednaci: XVal;
									datumZapisu: XVal;
									id: XVal;
								}[];
								vyjimkyNaZbranKategorieR1: {
									cisloJednaci: XVal;
									datumZapisu: XVal;
									druhZbrane: {
										kod: XVal;
										value: XVal;
									};
									vyrobce: {
										kod: XVal;
										value: XVal;
									};
									model: {
										kod: XVal;
										value: XVal;
									};
									raze?: Raze | Raze[];
									vyrobniCislo: XVal | XVal[];
									id: XVal;
								}[];
								vyjimkyNaZbranStrelivoKategorieR2S2: {
									cisloJednaci: XVal;
									datumZapisu: XVal;
									predmetVyjimky: {
										kod: XVal;
										value: XVal;
									};
									id: XVal;
								}[];
								vyjimkyNaStrelivoS1: {
									cisloJednaci: XVal;
									datumZapisu: XVal;
									raze: Raze | Raze[];
									pocetKusu: XVal;
									zbyvajiciPocetKusu: XVal;
									id: XVal;
								}[];
							};
						};
				  }
				| undefined;
		},
		{
			egsb: {
				xAttStatus: string;
				xAttGuuid: string;
			};
		},
	];
};
